import React, { ReactNode } from 'react';

import CustomLineChart, { IBasicLineChart } from './CustomLineChart';
import { containerClass } from './style.css';
import ColoredChartText from '../colored-chart-text/ColoredChartText';

export interface LineChartProps extends Omit<IBasicLineChart, 'height'> {
	desc?: ReactNode;
	subDesc?: string;
	graphHeight?: number;
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const LineChart = ({
	desc,
	subDesc,
	width = 230,
	graphHeight = 152,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: LineChartProps) => {
	const unavailableProps = { ...props };

	if (isLoading || isError) {
		unavailableProps.categorys = [];
		unavailableProps.datas_a = [];
		unavailableProps.data_name_a = '???';
	} else if (lackOfPermission) {
		unavailableProps.categorys = [];
		unavailableProps.datas_a = [100, 200, 200, 300, 400];
		unavailableProps.data_name_a = '???';
		unavailableProps.isPositive = true;
	}

	const available = !isLoading && !isError && !lackOfPermission;

	return (
		<div className={containerClass}>
			{desc && (
				<ColoredChartText
					subText={subDesc}
					isLoading={isLoading}
					isError={isError}
					lackOfPermission={lackOfPermission}
				>
					{desc}
				</ColoredChartText>
			)}
			{available && <CustomLineChart {...props} width={width} height={graphHeight} />}
			{!available && (
				<CustomLineChart
					{...unavailableProps}
					axisType={'category'}
					width={width}
					height={graphHeight}
				/>
			)}
		</div>
	);
};

export default LineChart;
